import { render, staticRenderFns } from "./AHproView.vue?vue&type=template&id=54886212&scoped=true&"
import script from "./AHproView.vue?vue&type=script&lang=js&"
export * from "./AHproView.vue?vue&type=script&lang=js&"
import style0 from "./AHproView.vue?vue&type=style&index=0&id=54886212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54886212",
  null
  
)

export default component.exports